import { useRef } from 'react';
import { useSnowplowHelpers } from '@mindtickle/snowplow-client';

import { withErrorBoundary } from '~/components/Tools';
import { DEFAULT_ERROR_FALLBACK as ErrorFallback } from '~/config/app.constants';

function BlockingIntegrations({ children }: { children: JSX.Element }) {
  const integrationsAlreadyInitialized = useRef(false);

  const { load: loadSnowplow } = useSnowplowHelpers();

  if (!integrationsAlreadyInitialized.current) {
    loadSnowplow();
    integrationsAlreadyInitialized.current = true;
  }

  return children;
}

export default withErrorBoundary(BlockingIntegrations, {
  fallback: ({ error, ...rest }) => (
    <ErrorFallback error={error} {...rest} message="Error captured in Blocking Integration" />
  ),
});
